import { render, staticRenderFns } from "./SuccessLetter.vue?vue&type=template&id=46c13796&scoped=true&"
import script from "./SuccessLetter.vue?vue&type=script&lang=js&"
export * from "./SuccessLetter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46c13796",
  null
  
)

export default component.exports